<template>
  <el-dialog
    title="选择部门"
    :visible="visible"
    width="50%"
    @open="handleOpen"
    @close="handleClose"
    append-to-body
    destroy-on-close
  >
<!--    <div style="height: 300px">-->
    <div>
      <el-tree
        highlight-current
        :data="data"
        :props="defaultProp"
        @node-click="handleNodeClick"
      ></el-tree>
    </div>
    <div slot="footer">
      <el-button type="primary" size="small" @click="handleConfirm"
        >确定</el-button
      >
      <el-button size="small" @click="handleClose">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { selectDept } from "@/api/system/dept";
import { toTree } from "@/utils";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    userDept: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: [],
      selectNode: null,
      defaultProp: {
        label: "deptName",
        children: "children",
      },
    };
  },
  methods: {
    getDept() {
      selectDept(this.userDept ? { type: "USER" } : {}).then((res) => {
        this.data = toTree(res, this.userDept ? 0 : -1);
      });
    },
    handleNodeClick(data) {
      this.selectNode = data;
    },
    handleConfirm() {
      if (this.selectNode) {
        this.$emit("confirm", this.selectNode);
        this.handleClose();
      } else {
        this.$message({
          type: "warning",
          message: "请选择节点",
        });
      }
    },
    handleOpen() {
      this.getDept();
    },
    handleClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>







// WEBPACK FOOTER //
// src/views/components/dept.vue